import { cloneRemovingVueObserver } from '@/app/shared/utils/vue-observer-utils'
import { QuestionScore } from './question-score'

export interface QuestionStateMachineData {
  phase: QuestionPhase
  answer: QuestionAnswer | null
  state: QuestionState | null
  evaluation: {
    details: QuestionEvaluationResult
    result: EvaluationResultPhase
  }
}

export interface QuestionStateInput {
  state: { value: unknown } | null
  answer: { value: unknown } | null
  phase: QuestionPhase
  result: {
    score: number
  }
}

export function resetQuestionAnswerAndEvaluation(data: QuestionStateMachineData, questionScore: QuestionScore) {
  data.answer = null
  data.evaluation = defaultEvaluation(questionScore.min)
}

export function loadQuestionState(input: QuestionStateInput,
                                  questionScore: QuestionScore): QuestionStateMachineData {

  let evaluationResult: EvaluationResultPhase = 'not-evaluated'
  if (isQuestionPhaseAlreadyAnswered(input.phase)) {
    evaluationResult = determineEvaluationResult(input.result.score, questionScore)
  }
  
  return {
    state: input.state ? { state: input.state.value } : null,
    answer: input.answer ? { answer: input.answer.value } : null,
    phase: input.phase,
    evaluation: {
      details: { score: input.result.score },
      result: evaluationResult
    }
  }
}

export function saveQuestionState(data: QuestionStateMachineData) {
  return  {
    state: data.state ? cloneStateValue(data.state.state) : null,
    answer: data.answer ? cloneStateValue(data.answer.answer) : null,
    phase: data.phase,
    result: {
      score: data.evaluation.details.score
    }
  }

  function cloneStateValue(input: unknown) {
    return {
      value: cloneRemovingVueObserver(input)
    }
  }
}

export type QuestionPhase = 'not-answered' | 'answered' | 'evaluated' | 'solution-shown'
export function isQuestionPhaseEvaluated(questionPhase: QuestionPhase) {
  return questionPhase === 'evaluated' || questionPhase === 'solution-shown'
}
export function isQuestionPhaseAlreadyAnswered(questionPhase: QuestionPhase) {
  return questionPhase === 'answered' || isQuestionPhaseEvaluated(questionPhase)
}

export interface QuestionState {
  state: unknown
}

export interface QuestionAnswer {
  answer: unknown
}

export interface QuestionEvaluationResult {
  score: number
}

export type EvaluationResultPhase = 'not-evaluated' | 'correct' | 'partially-correct' | 'incorrect'

export function defaultQuestionStateMachineData(minScore: number): QuestionStateMachineData {
  return {
    phase: 'not-answered',
    state: null,
    answer: null,
    evaluation: defaultEvaluation(minScore)
  }
}

export function defaultEvaluation(minScore: number) {
  return {
    details: { score: minScore },
    result: 'not-evaluated' as EvaluationResultPhase

  }
}

export function determineEvaluationResult(score: number,
                                          questionScore: QuestionScore): EvaluationResultPhase {
  
  if (score === questionScore.max) {
    return 'correct'
  } else if (score > questionScore.min) {
    return 'partially-correct'
  } else {
    return 'incorrect'
  }    
}
